import { render, staticRenderFns } from "./Nuevo.vue?vue&type=template&id=c35109fa"
import script from "./Nuevo.vue?vue&type=script&lang=js"
export * from "./Nuevo.vue?vue&type=script&lang=js"
import style0 from "./Nuevo.vue?vue&type=style&index=0&id=c35109fa&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports